import React from 'react';
import ReactDOM from 'react-dom';

import "./index.scss"
import Game from "src/components/Game"

ReactDOM.render(
  <Game />,
  document.getElementById('root')
);